angular.module('leanlaw').filter("limitText", ['$filter', function ($filter) {
  return function (text, limit) {
    if (!text) return "";
    if (!limit || text.length <= limit) return text;
    return text.substring(0, limit) + "...";
  };
}]);